import { render, staticRenderFns } from "./ExportarOfertaInscricaoWeb.vue?vue&type=template&id=97b6eb54&scoped=true&"
import script from "./ExportarOfertaInscricaoWeb.vue?vue&type=script&lang=js&"
export * from "./ExportarOfertaInscricaoWeb.vue?vue&type=script&lang=js&"
import style0 from "./ExportarOfertaInscricaoWeb.vue?vue&type=style&index=0&id=97b6eb54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b6eb54",
  null
  
)

export default component.exports